(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
let $91b3424afa0e0363$var$googleMapsPromise = null;
function $91b3424afa0e0363$export$12ead4d9d7e8e411(apiKey) {
    if ($91b3424afa0e0363$var$googleMapsPromise) return $91b3424afa0e0363$var$googleMapsPromise;
    $91b3424afa0e0363$var$googleMapsPromise = new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=weekly`;
        script.async = true;
        script.defer = true;
        script.onload = async ()=>{
            try {
                await google.maps.importLibrary("maps");
                await google.maps.importLibrary("marker");
                resolve();
            } catch (err) {
                reject(err);
            }
        };
        script.onerror = ()=>reject(new Error("Google Maps API script failed to load"));
        document.head.appendChild(script);
    });
    return $91b3424afa0e0363$var$googleMapsPromise;
}


var $80313a72c8cc9578$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$80313a72c8cc9578$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


const $c509ce46a93fe9c2$var$ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */ const $c509ce46a93fe9c2$var$VERSION = 1; // serialized format version
const $c509ce46a93fe9c2$var$HEADER_SIZE = 8;
class $c509ce46a93fe9c2$export$2e2bcd8739ae039 {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */ static from(data) {
        if (!(data instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
        const [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) throw new Error("Data does not appear to be in a KDBush format.");
        const version = versionAndType >> 4;
        if (version !== $c509ce46a93fe9c2$var$VERSION) throw new Error(`Got v${version} data when expected v${$c509ce46a93fe9c2$var$VERSION}.`);
        const ArrayType = $c509ce46a93fe9c2$var$ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) throw new Error("Unrecognized array type.");
        const [nodeSize] = new Uint16Array(data, 2, 1);
        const [numItems] = new Uint32Array(data, 4, 1);
        return new $c509ce46a93fe9c2$export$2e2bcd8739ae039(numItems, nodeSize, ArrayType, data);
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */ constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data){
        if (isNaN(numItems) || numItems < 0) throw new Error(`Unpexpected numItems value: ${numItems}.`);
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
        const arrayTypeIndex = $c509ce46a93fe9c2$var$ARRAY_TYPES.indexOf(this.ArrayType);
        const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        const padCoords = (8 - idsByteSize % 8) % 8;
        if (arrayTypeIndex < 0) throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        if (data && data instanceof ArrayBuffer) {
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else {
            this.data = new ArrayBuffer($c509ce46a93fe9c2$var$HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;
            // set header
            new Uint8Array(this.data, 0, 2).set([
                0xdb,
                ($c509ce46a93fe9c2$var$VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */ add(x, y) {
        const index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }
    /**
     * Perform indexing of the added points.
     */ finish() {
        const numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
        // kd-sort both arrays for efficient search
        $c509ce46a93fe9c2$var$sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
        this._finished = true;
        return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */ range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        // recursively search for items in range in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++){
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                }
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */ within(qx, qy, r) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        const r2 = r * r;
        // recursively search for items within radius in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++)if ($c509ce46a93fe9c2$var$sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if ($c509ce46a93fe9c2$var$sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $c509ce46a93fe9c2$var$sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    const m = left + right >> 1; // middle index
    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    $c509ce46a93fe9c2$var$select(ids, coords, m, left, right, axis);
    // recursively kd-sort first half and second half on the opposite axis
    $c509ce46a93fe9c2$var$sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    $c509ce46a93fe9c2$var$sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}
/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $c509ce46a93fe9c2$var$select(ids, coords, k, left, right, axis) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $c509ce46a93fe9c2$var$select(ids, coords, k, newLeft, newRight, axis);
        }
        const t = coords[2 * k + axis];
        let i = left;
        let j = right;
        $c509ce46a93fe9c2$var$swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) $c509ce46a93fe9c2$var$swapItem(ids, coords, left, right);
        while(i < j){
            $c509ce46a93fe9c2$var$swapItem(ids, coords, i, j);
            i++;
            j--;
            while(coords[2 * i + axis] < t)i++;
            while(coords[2 * j + axis] > t)j--;
        }
        if (coords[2 * left + axis] === t) $c509ce46a93fe9c2$var$swapItem(ids, coords, left, j);
        else {
            j++;
            $c509ce46a93fe9c2$var$swapItem(ids, coords, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */ function $c509ce46a93fe9c2$var$swapItem(ids, coords, i, j) {
    $c509ce46a93fe9c2$var$swap(ids, i, j);
    $c509ce46a93fe9c2$var$swap(coords, 2 * i, 2 * j);
    $c509ce46a93fe9c2$var$swap(coords, 2 * i + 1, 2 * j + 1);
}
/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */ function $c509ce46a93fe9c2$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function $c509ce46a93fe9c2$var$sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}


const $a4cd6cdb96430eae$var$defaultOptions = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: false,
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // properties to use for individual points when running the reducer
    map: (props)=>props // props => ({sum: props.my_value})
};
const $a4cd6cdb96430eae$var$fround = Math.fround || ((tmp)=>(x)=>{
        tmp[0] = +x;
        return tmp[0];
    })(new Float32Array(1));
const $a4cd6cdb96430eae$var$OFFSET_ZOOM = 2;
const $a4cd6cdb96430eae$var$OFFSET_ID = 3;
const $a4cd6cdb96430eae$var$OFFSET_PARENT = 4;
const $a4cd6cdb96430eae$var$OFFSET_NUM = 5;
const $a4cd6cdb96430eae$var$OFFSET_PROP = 6;
class $a4cd6cdb96430eae$export$2e2bcd8739ae039 {
    constructor(options){
        this.options = Object.assign(Object.create($a4cd6cdb96430eae$var$defaultOptions), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }
    load(points) {
        const { log: log, minZoom: minZoom, maxZoom: maxZoom } = this.options;
        if (log) console.time("total time");
        const timerId = `prepare ${points.length} points`;
        if (log) console.time(timerId);
        this.points = points;
        // generate a cluster object for each point and index input points into a KD-tree
        const data = [];
        for(let i = 0; i < points.length; i++){
            const p = points[i];
            if (!p.geometry) continue;
            const [lng, lat] = p.geometry.coordinates;
            const x = $a4cd6cdb96430eae$var$fround($a4cd6cdb96430eae$var$lngX(lng));
            const y = $a4cd6cdb96430eae$var$fround($a4cd6cdb96430eae$var$latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(x, y, Infinity, i, -1, 1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        let tree = this.trees[maxZoom + 1] = this._createTree(data);
        if (log) console.timeEnd(timerId);
        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for(let z = maxZoom; z >= minZoom; z--){
            const now = +Date.now();
            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));
            if (log) console.log("z%d: %d clusters in %dms", z, tree.numItems, +Date.now() - now);
        }
        if (log) console.timeEnd("total time");
        return this;
    }
    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));
        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([
                minLng,
                minLat,
                180,
                maxLat
            ], zoom);
            const westernHem = this.getClusters([
                -180,
                minLat,
                maxLng,
                maxLat
            ], zoom);
            return easternHem.concat(westernHem);
        }
        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range($a4cd6cdb96430eae$var$lngX(minLng), $a4cd6cdb96430eae$var$latY(maxLat), $a4cd6cdb96430eae$var$lngX(maxLng), $a4cd6cdb96430eae$var$latY(minLat));
        const data = tree.data;
        const clusters = [];
        for (const id of ids){
            const k = this.stride * id;
            clusters.push(data[k + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1 ? $a4cd6cdb96430eae$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]]);
        }
        return clusters;
    }
    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = "No cluster with the specified id.";
        const tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);
        const data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);
        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const x = data[originId * this.stride];
        const y = data[originId * this.stride + 1];
        const ids = tree.within(x, y, r);
        const children = [];
        for (const id of ids){
            const k = id * this.stride;
            if (data[k + $a4cd6cdb96430eae$var$OFFSET_PARENT] === clusterId) children.push(data[k + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1 ? $a4cd6cdb96430eae$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]]);
        }
        if (children.length === 0) throw new Error(errorMsg);
        return children;
    }
    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;
        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);
        return leaves;
    }
    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const { extent: extent, radius: radius } = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;
        const tile = {
            features: []
        };
        this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.data, x, y, z2, tile);
        if (x === 0) this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.data, z2, y, z2, tile);
        if (x === z2 - 1) this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.data, -1, y, z2, tile);
        return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while(expansionZoom <= this.options.maxZoom){
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);
        for (const child of children){
            const props = child.properties;
            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) // skip the whole cluster
                skipped += props.point_count;
                else // enter the cluster
                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
            } else if (skipped < offset) // skip a single point
            skipped++;
            else // add a single point
            result.push(child);
            if (result.length === limit) break;
        }
        return skipped;
    }
    _createTree(data) {
        const tree = new (0, $c509ce46a93fe9c2$export$2e2bcd8739ae039)(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(let i = 0; i < data.length; i += this.stride)tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (const i of ids){
            const k = i * this.stride;
            const isCluster = data[k + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1;
            let tags, px, py;
            if (isCluster) {
                tags = $a4cd6cdb96430eae$var$getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                const p = this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]];
                tags = p.properties;
                const [lng, lat] = p.geometry.coordinates;
                px = $a4cd6cdb96430eae$var$lngX(lng);
                py = $a4cd6cdb96430eae$var$latY(lat);
            }
            const f = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (px * z2 - x)),
                        Math.round(this.options.extent * (py * z2 - y))
                    ]
                ],
                tags: tags
            };
            // assign id
            let id;
            if (isCluster || this.options.generateId) // optionally generate id for points
            id = data[k + $a4cd6cdb96430eae$var$OFFSET_ID];
            else // keep id if already assigned
            id = this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]].id;
            if (id !== undefined) f.id = id;
            tile.features.push(f);
        }
    }
    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
        const { radius: radius, extent: extent, reduce: reduce, minPoints: minPoints } = this.options;
        const r = radius / (extent * Math.pow(2, zoom));
        const data = tree.data;
        const nextData = [];
        const stride = this.stride;
        // loop through each point
        for(let i = 0; i < data.length; i += stride){
            // if we've already visited the point at this zoom level, skip it
            if (data[i + $a4cd6cdb96430eae$var$OFFSET_ZOOM] <= zoom) continue;
            data[i + $a4cd6cdb96430eae$var$OFFSET_ZOOM] = zoom;
            // find all nearby points
            const x = data[i];
            const y = data[i + 1];
            const neighborIds = tree.within(data[i], data[i + 1], r);
            const numPointsOrigin = data[i + $a4cd6cdb96430eae$var$OFFSET_NUM];
            let numPoints = numPointsOrigin;
            // count the number of points in a potential cluster
            for (const neighborId of neighborIds){
                const k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] > zoom) numPoints += data[k + $a4cd6cdb96430eae$var$OFFSET_NUM];
            }
            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = x * numPointsOrigin;
                let wy = y * numPointsOrigin;
                let clusterProperties;
                let clusterPropIndex = -1;
                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
                for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)
                    const numPoints2 = data[k + $a4cd6cdb96430eae$var$OFFSET_NUM];
                    wx += data[k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[k + 1] * numPoints2;
                    data[k + $a4cd6cdb96430eae$var$OFFSET_PARENT] = id;
                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, k));
                    }
                }
                data[i + $a4cd6cdb96430eae$var$OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);
            } else {
                for(let j = 0; j < stride; j++)nextData.push(data[i + j]);
                if (numPoints > 1) for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] = zoom;
                    for(let j = 0; j < stride; j++)nextData.push(data[k + j]);
                }
            }
        }
        return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
        if (data[i + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1) {
            const props = this.clusterProps[data[i + $a4cd6cdb96430eae$var$OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        const original = this.points[data[i + $a4cd6cdb96430eae$var$OFFSET_ID]].properties;
        const result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
}
function $a4cd6cdb96430eae$var$getClusterJSON(data, i, clusterProps) {
    return {
        type: "Feature",
        id: data[i + $a4cd6cdb96430eae$var$OFFSET_ID],
        properties: $a4cd6cdb96430eae$var$getClusterProperties(data, i, clusterProps),
        geometry: {
            type: "Point",
            coordinates: [
                $a4cd6cdb96430eae$var$xLng(data[i]),
                $a4cd6cdb96430eae$var$yLat(data[i + 1])
            ]
        }
    };
}
function $a4cd6cdb96430eae$var$getClusterProperties(data, i, clusterProps) {
    const count = data[i + $a4cd6cdb96430eae$var$OFFSET_NUM];
    const abbrev = count >= 10000 ? `${Math.round(count / 1000)}k` : count >= 1000 ? `${Math.round(count / 100) / 10}k` : count;
    const propIndex = data[i + $a4cd6cdb96430eae$var$OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + $a4cd6cdb96430eae$var$OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
// longitude/latitude to spherical mercator in [0..1] range
function $a4cd6cdb96430eae$var$lngX(lng) {
    return lng / 360 + 0.5;
}
function $a4cd6cdb96430eae$var$latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
// spherical mercator to longitude/latitude
function $a4cd6cdb96430eae$var$xLng(x) {
    return (x - 0.5) * 360;
}
function $a4cd6cdb96430eae$var$yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $b91f9f2fdb98b359$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * util class that creates a common set of convenience functions to wrap
 * shared behavior of Advanced Markers and Markers.
 */ class $b91f9f2fdb98b359$export$87c23728007fa1bd {
    static isAdvancedMarkerAvailable(map) {
        return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
        return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
        if (this.isAdvancedMarker(marker)) marker.map = map;
        else marker.setMap(map);
    }
    static getPosition(marker) {
        // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
        if (this.isAdvancedMarker(marker)) {
            if (marker.position) {
                if (marker.position instanceof google.maps.LatLng) return marker.position;
                // since we can't cast to LatLngLiteral for reasons =(
                if (marker.position.lat && marker.position.lng) return new google.maps.LatLng(marker.position.lat, marker.position.lng);
            }
            return new google.maps.LatLng(null);
        }
        return marker.getPosition();
    }
    static getVisible(marker) {
        if (this.isAdvancedMarker(marker)) /**
             * Always return true for Advanced Markers because the clusterer
             * uses getVisible as a way to count legacy markers not as an actual
             * indicator of visibility for some reason. Even when markers are hidden
             * Marker.getVisible returns `true` and this is used to set the marker count
             * on the cluster. See the behavior of Cluster.count
             */ return true;
        return marker.getVisible();
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b91f9f2fdb98b359$export$57ed47926628b770 {
    constructor({ markers: markers, position: position }){
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) this._position = position;
            else this._position = new google.maps.LatLng(position);
        }
    }
    get bounds() {
        if (this.markers.length === 0 && !this._position) return;
        const bounds = new google.maps.LatLngBounds(this._position, this._position);
        for (const marker of this.markers)bounds.extend($b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker));
        return bounds;
    }
    get position() {
        return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */ get count() {
        return this.markers.filter((m)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */ push(marker) {
        this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */ delete() {
        if (this.marker) {
            $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(this.marker, null);
            this.marker = undefined;
        }
        this.markers.length = 0;
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the markers visible in a padded map viewport
 *
 * @param map
 * @param mapCanvasProjection
 * @param markers The list of marker to filter
 * @param viewportPaddingPixels The padding in pixel
 * @returns The list of markers in the padded viewport
 */ const $b91f9f2fdb98b359$export$6dcea57a2b662207 = (map, mapCanvasProjection, markers, viewportPaddingPixels)=>{
    const extendedMapBounds = $b91f9f2fdb98b359$export$57247bea612a5e84(map.getBounds(), mapCanvasProjection, viewportPaddingPixels);
    return markers.filter((marker)=>extendedMapBounds.contains($b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker)));
};
/**
 * Extends a bounds by a number of pixels in each direction
 */ const $b91f9f2fdb98b359$export$57247bea612a5e84 = (bounds, projection, numPixels)=>{
    const { northEast: northEast, southWest: southWest } = $b91f9f2fdb98b359$var$latLngBoundsToPixelBounds(bounds, projection);
    const extendedPixelBounds = $b91f9f2fdb98b359$export$8cd793acb3b8e8e8({
        northEast: northEast,
        southWest: southWest
    }, numPixels);
    return $b91f9f2fdb98b359$export$21d7a872d22a0f92(extendedPixelBounds, projection);
};
/**
 * Gets the extended bounds as a bbox [westLng, southLat, eastLng, northLat]
 */ const $b91f9f2fdb98b359$export$6341d7e267bda241 = (bounds, projection, pixels)=>{
    const extended = $b91f9f2fdb98b359$export$57247bea612a5e84(bounds, projection, pixels);
    const ne = extended.getNorthEast();
    const sw = extended.getSouthWest();
    return [
        sw.lng(),
        sw.lat(),
        ne.lng(),
        ne.lat()
    ];
};
/**
 * Returns the distance between 2 positions.
 *
 * @hidden
 */ const $b91f9f2fdb98b359$export$b59117efbc9c7af = (p1, p2)=>{
    const R = 6371; // Radius of the Earth in km
    const dLat = (p2.lat - p1.lat) * Math.PI / 180;
    const dLon = (p2.lng - p1.lng) * Math.PI / 180;
    const sinDLat = Math.sin(dLat / 2);
    const sinDLon = Math.sin(dLon / 2);
    const a = sinDLat * sinDLat + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * sinDLon * sinDLon;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * Converts a LatLng bound to pixels.
 *
 * @hidden
 */ const $b91f9f2fdb98b359$var$latLngBoundsToPixelBounds = (bounds, projection)=>{
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest())
    };
};
/**
 * Extends a pixel bounds by numPixels in all directions.
 *
 * @hidden
 */ const $b91f9f2fdb98b359$export$8cd793acb3b8e8e8 = ({ northEast: northEast, southWest: southWest }, numPixels)=>{
    northEast.x += numPixels;
    northEast.y -= numPixels;
    southWest.x -= numPixels;
    southWest.y += numPixels;
    return {
        northEast: northEast,
        southWest: southWest
    };
};
/**
 * @hidden
 */ const $b91f9f2fdb98b359$export$21d7a872d22a0f92 = ({ northEast: northEast, southWest: southWest }, projection)=>{
    const sw = projection.fromDivPixelToLatLng(southWest);
    const ne = projection.fromDivPixelToLatLng(northEast);
    return new google.maps.LatLngBounds(sw, ne);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @hidden
 */ class $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor({ maxZoom: maxZoom = 16 }){
        this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */ noop({ markers: markers }) {
        return $b91f9f2fdb98b359$export$8793edee2d425525(markers);
    }
}
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */ class $b91f9f2fdb98b359$export$d8a438b9a55dba76 extends $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor(_a){
        var { viewportPadding: viewportPadding = 60 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "viewportPadding"
        ]);
        super(options);
        this.viewportPadding = 60;
        this.viewportPadding = viewportPadding;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: false
        };
        return {
            clusters: this.cluster({
                markers: $b91f9f2fdb98b359$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
}
/**
 * @hidden
 */ const $b91f9f2fdb98b359$export$8793edee2d425525 = (markers)=>{
    const clusters = markers.map((marker)=>new $b91f9f2fdb98b359$export$57ed47926628b770({
            position: $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker),
            markers: [
                marker
            ]
        }));
    return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */ class $b91f9f2fdb98b359$export$dfa3b6d6f10e5cac extends $b91f9f2fdb98b359$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxDistance: maxDistance = 40000, gridSize: gridSize = 40 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "maxDistance",
            "gridSize"
        ]);
        super(options);
        this.clusters = [];
        this.state = {
            zoom: -1
        };
        this.maxDistance = maxDistance;
        this.gridSize = gridSize;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        const state = {
            zoom: map.getZoom()
        };
        let changed = false;
        if (this.state.zoom >= this.maxZoom && state.zoom >= this.maxZoom) ;
        else changed = !(0, (/*@__PURE__*/$parcel$interopDefault($80313a72c8cc9578$exports)))(this.state, state);
        this.state = state;
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: changed
        };
        return {
            clusters: this.cluster({
                markers: $b91f9f2fdb98b359$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
    cluster({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        this.clusters = [];
        markers.forEach((marker)=>{
            this.addToClosestCluster(marker, map, mapCanvasProjection);
        });
        return this.clusters;
    }
    addToClosestCluster(marker, map, projection) {
        let maxDistance = this.maxDistance; // Some large number
        let cluster = null;
        for(let i = 0; i < this.clusters.length; i++){
            const candidate = this.clusters[i];
            const distance = $b91f9f2fdb98b359$export$b59117efbc9c7af(candidate.bounds.getCenter().toJSON(), $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker).toJSON());
            if (distance < maxDistance) {
                maxDistance = distance;
                cluster = candidate;
            }
        }
        if (cluster && $b91f9f2fdb98b359$export$57247bea612a5e84(cluster.bounds, projection, this.gridSize).contains($b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker))) cluster.push(marker);
        else {
            const cluster = new $b91f9f2fdb98b359$export$57ed47926628b770({
                markers: [
                    marker
                ]
            });
            this.clusters.push(cluster);
        }
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */ class $b91f9f2fdb98b359$export$f6cacfea2ccd84d3 extends $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor(_a){
        var options = $b91f9f2fdb98b359$var$__rest(_a, []);
        super(options);
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        return {
            clusters: this.cluster({
                markers: markers,
                map: map,
                mapCanvasProjection: mapCanvasProjection
            }),
            changed: false
        };
    }
    cluster(input) {
        return this.noop(input);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $b91f9f2fdb98b359$export$3c4c9430ac0fb1eb extends $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "maxZoom",
            "radius"
        ]);
        super({
            maxZoom: maxZoom
        });
        this.state = {
            zoom: -1
        };
        this.superCluster = new (0, $a4cd6cdb96430eae$export$2e2bcd8739ae039)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
    }
    calculate(input) {
        let changed = false;
        const state = {
            zoom: input.map.getZoom()
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($80313a72c8cc9578$exports)))(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (!changed) {
            if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) changed = !(0, (/*@__PURE__*/$parcel$interopDefault($80313a72c8cc9578$exports)))(this.state, state);
        }
        this.state = state;
        if (changed) this.clusters = this.cluster(input);
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map }) {
        return this.superCluster.getClusters([
            -180,
            -90,
            180,
            90
        ], Math.round(map.getZoom())).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $b91f9f2fdb98b359$export$80a71135475bbaa7 extends $b91f9f2fdb98b359$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60, viewportPadding: viewportPadding = 60 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "maxZoom",
            "radius",
            "viewportPadding"
        ]);
        super({
            maxZoom: maxZoom,
            viewportPadding: viewportPadding
        });
        this.superCluster = new (0, $a4cd6cdb96430eae$export$2e2bcd8739ae039)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
        this.state = {
            zoom: -1,
            view: [
                0,
                0,
                0,
                0
            ]
        };
    }
    calculate(input) {
        const state = {
            zoom: Math.round(input.map.getZoom()),
            view: $b91f9f2fdb98b359$export$6341d7e267bda241(input.map.getBounds(), input.mapCanvasProjection, this.viewportPadding)
        };
        let changed = !(0, (/*@__PURE__*/$parcel$interopDefault($80313a72c8cc9578$exports)))(this.state, state);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($80313a72c8cc9578$exports)))(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (changed) {
            this.clusters = this.cluster(input);
            this.state = state;
        }
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map, mapCanvasProjection: mapCanvasProjection }) {
        /* recalculate new state because we can't use the cached version. */ const state = {
            zoom: Math.round(map.getZoom()),
            view: $b91f9f2fdb98b359$export$6341d7e267bda241(map.getBounds(), mapCanvasProjection, this.viewportPadding)
        };
        return this.superCluster.getClusters(state.view, state.zoom).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */ class $b91f9f2fdb98b359$export$2deda6e6beba3286 {
    constructor(markers, clusters){
        this.markers = {
            sum: markers.length
        };
        const clusterMarkerCounts = clusters.map((a)=>a.count);
        const clusterMarkerSum = clusterMarkerCounts.reduce((a, b)=>a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts)
            }
        };
    }
}
class $b91f9f2fdb98b359$export$7db59afbbd5bcace {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */ render({ count: count, position: position }, stats, map) {
        // change color if this cluster has more markers than the mean cluster
        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg literal with fill color
        const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
        const title = `Cluster of ${count} markers`, // adjust zIndex to be above other markers
        zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
        if ($b91f9f2fdb98b359$export$87c23728007fa1bd.isAdvancedMarkerAvailable(map)) {
            // create cluster SVG element
            const parser = new DOMParser();
            const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
            svgEl.setAttribute("transform", "translate(0 25)");
            const clusterOptions = {
                map: map,
                position: position,
                zIndex: zIndex,
                title: title,
                content: svgEl
            };
            return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
        }
        const clusterOptions = {
            position: position,
            zIndex: zIndex,
            title: title,
            icon: {
                url: `data:image/svg+xml;base64,${btoa(svg)}`,
                anchor: new google.maps.Point(25, 25)
            }
        };
        return new google.maps.Marker(clusterOptions);
    }
}
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b91f9f2fdb98b359$var$extend(type1, type2) {
    /* istanbul ignore next */ // eslint-disable-next-line prefer-const
    for(let property in type2.prototype)type1.prototype[property] = type2.prototype[property];
}
/**
 * @ignore
 */ class $b91f9f2fdb98b359$var$OverlayViewSafe {
    constructor(){
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        $b91f9f2fdb98b359$var$extend($b91f9f2fdb98b359$var$OverlayViewSafe, google.maps.OverlayView);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b91f9f2fdb98b359$export$f87b0506a2cf0bc;
(function(MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})($b91f9f2fdb98b359$export$f87b0506a2cf0bc || ($b91f9f2fdb98b359$export$f87b0506a2cf0bc = {}));
const $b91f9f2fdb98b359$export$b434dc9855552644 = (_, cluster, map)=>{
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */ class $b91f9f2fdb98b359$export$58bd9bb9fcf3dd4f extends $b91f9f2fdb98b359$var$OverlayViewSafe {
    constructor({ map: map, markers: markers = [], algorithmOptions: algorithmOptions = {}, algorithm: algorithm = new $b91f9f2fdb98b359$export$3c4c9430ac0fb1eb(algorithmOptions), renderer: renderer = new $b91f9f2fdb98b359$export$7db59afbbd5bcace(), onClusterClick: onClusterClick = $b91f9f2fdb98b359$export$b434dc9855552644 }){
        super();
        this.markers = [
            ...markers
        ];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) this.setMap(map);
    }
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) return;
        this.markers.push(marker);
        if (!noDraw) this.render();
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker)=>{
            this.addMarker(marker, true);
        });
        if (!noDraw) this.render();
    }
    removeMarker(marker, noDraw) {
        const index = this.markers.indexOf(marker);
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) this.render();
        return true;
    }
    removeMarkers(markers, noDraw) {
        let removed = false;
        markers.forEach((marker)=>{
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) this.render();
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) this.render();
    }
    /**
     * Recalculates and draws all the marker clusters.
     */ render() {
        const map = this.getMap();
        if (map instanceof google.maps.Map && map.getProjection()) {
            google.maps.event.trigger(this, $b91f9f2fdb98b359$export$f87b0506a2cf0bc.CLUSTERING_BEGIN, this);
            const { clusters: clusters, changed: changed } = this.algorithm.calculate({
                markers: this.markers,
                map: map,
                mapCanvasProjection: this.getProjection()
            });
            // Allow algorithms to return flag on whether the clusters/markers have changed.
            if (changed || changed == undefined) {
                // Accumulate the markers of the clusters composed of a single marker.
                // Those clusters directly use the marker.
                // Clusters with more than one markers use a group marker generated by a renderer.
                const singleMarker = new Set();
                for (const cluster of clusters)if (cluster.markers.length == 1) singleMarker.add(cluster.markers[0]);
                const groupMarkers = [];
                // Iterate the clusters that are currently rendered.
                for (const cluster of this.clusters){
                    if (cluster.marker == null) continue;
                    if (cluster.markers.length == 1) {
                        if (!singleMarker.has(cluster.marker)) // The marker:
                        // - was previously rendered because it is from a cluster with 1 marker,
                        // - should no more be rendered as it is not in singleMarker.
                        $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(cluster.marker, null);
                    } else // Delay the removal of old group markers to avoid flickering.
                    groupMarkers.push(cluster.marker);
                }
                this.clusters = clusters;
                this.renderClusters();
                // Delayed removal of the markers of the former groups.
                requestAnimationFrame(()=>groupMarkers.forEach((marker)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null)));
            }
            google.maps.event.trigger(this, $b91f9f2fdb98b359$export$f87b0506a2cf0bc.CLUSTERING_END, this);
        }
    }
    onAdd() {
        this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null));
        this.clusters.forEach((cluster)=>cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // Generate stats to pass to renderers.
        const stats = new $b91f9f2fdb98b359$export$2deda6e6beba3286(this.markers, this.clusters);
        const map = this.getMap();
        this.clusters.forEach((cluster)=>{
            if (cluster.markers.length === 1) cluster.marker = cluster.markers[0];
            else {
                // Generate the marker to represent the group.
                cluster.marker = this.renderer.render(cluster, stats, map);
                // Make sure all individual markers are removed from the map.
                cluster.markers.forEach((marker)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null));
                if (this.onClusterClick) cluster.marker.addListener("click", /* istanbul ignore next */ (event)=>{
                    google.maps.event.trigger(this, $b91f9f2fdb98b359$export$f87b0506a2cf0bc.CLUSTER_CLICK, cluster);
                    this.onClusterClick(event, cluster, map);
                });
            }
            $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(cluster.marker, map);
        });
    }
}


class $94a9d645fcd9bc28$export$5cd6dd0a1d52a9dc {
    /**
     * Constructs a MapController instance.
     * 
     * @param mapId The ID of the DOM element to host the map.
     * @param googleMapsApiKey Google Maps API key for authorization.
     */ constructor(mapId, googleMapsApiKey){
        this.googleMapMarkerList = new Map();
        this.polylinesMap = new Map();
        this.mapId = mapId;
        this.googleMapsApiKey = googleMapsApiKey;
        this.adjustMapHeight = this.adjustMapHeight.bind(this);
        this.handleFullscreenChange = this.handleFullscreenChange.bind(this);
    }
    /**
     * Initializes the map centered at the provided latitude and longitude.
     * 
     * @async
     * @function
     * @param {number} latitude - The latitude of the center point of the map.
     * @param {number} longitude - The longitude of the center point of the map.
     * @param {autoHeightAdjustment} autoHeightAdjustment - The auto height adjustment flag.
     * @returns {Promise<void>} A promise that resolves when the map has been initialized.
     */ async init(latitude, longitude, autoHeightAdjustment) {
        this.mapInitializedPromise = new Promise((resolve, reject)=>{
            const div = document.getElementById(this.mapId);
            if (!div) {
                console.error("Map div not found");
                reject("Map div not found");
                return;
            }
            (0, $91b3424afa0e0363$export$12ead4d9d7e8e411)(this.googleMapsApiKey).then(()=>{
                const latlng = {
                    lat: latitude,
                    lng: longitude
                };
                const mapOptions = {
                    mapId: this.mapId,
                    zoom: 8,
                    center: latlng,
                    streetViewControl: false,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };
                this.googleMapInstance = new google.maps.Map(div, mapOptions);
                const renderer = {
                    render: ({ count: count, position: position })=>new google.maps.Marker({
                            label: {
                                text: String(count),
                                color: "white",
                                fontSize: "12px"
                            },
                            position: position,
                            icon: "images/map-markers/ClustererMarker.svg",
                            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
                        })
                };
                var markers = Array.from(this.googleMapMarkerList.values());
                this.markerClusterer = new (0, $b91f9f2fdb98b359$export$58bd9bb9fcf3dd4f)({
                    map: this.googleMapInstance,
                    markers: markers,
                    renderer: renderer
                });
                if (autoHeightAdjustment) {
                    window.addEventListener("resize", this.adjustMapHeight);
                    this.adjustMapHeight();
                }
                window.addEventListener("fullscreenchange", this.handleFullscreenChange);
                resolve();
            }).catch((error)=>{
                console.error("Failed to load Google Maps API", error);
                reject(error);
            });
        });
        return this.mapInitializedPromise;
    }
    /**
     * Adds a custom control to the map at the specified position.
     * 
     * This method allows integrating custom UI elements into the map, enhancing interactivity
     * and providing additional functionalities to the user. The custom control is identified
     * by an element ID and placed at a defined position on the map.
     * 
     * @param itemId The ID of the DOM element to be used as the control.
     * @param position The position for the control on the map, based on google.maps.ControlPosition values.
     * @returns Promise that resolves once the control is successfully added to the map.
     */ async addCustomControl(itemId, position) {
        if (!await this.isMapInitialized()) return;
        var element = document.getElementById(itemId);
        if (!element) {
            console.warn(`The custom control item id: (${itemId}) doesn't exist.`);
            return;
        }
        const controlPosition = google.maps.ControlPosition[position];
        this.googleMapInstance?.controls[controlPosition].push(element);
    }
    /**
     * Sets the center of the Google Map to the specified geographic coordinates.
     * 
     * @param latitude The latitude coordinate to center the map on.
     * @param longitude The longitude coordinate to center the map on.
     * @returns A promise that resolves once the center of the map has been updated.
    */ async setCenter(latitude, longitude) {
        if (!await this.isMapInitialized()) return;
        const latlng = {
            lat: latitude,
            lng: longitude
        };
        this.googleMapInstance.setCenter(latlng);
    }
    /**
     * Sets the zoom level of the map.
     * This method adjusts how zoomed in or out the map view is.
     *
     * @param zoom The zoom level to set the map to.
     * @returns A promise that resolves once the map's zoom level has been updated.
     */ async setZoom(zoom) {
        if (!await this.isMapInitialized()) return;
        this.googleMapInstance.setZoom(zoom);
    }
    /**
     * Automatically adjusts the map view to include a specific geographical area, based on the current markers.
     * This may adjust both the center and zoom of the map to ensure all relevant points are visible.
     *
     * @returns A promise that resolves once the map's bounds have been updated to include the specified area.
     */ async setBounds() {
        if (!await this.isMapInitialized()) return;
        const bounds = new google.maps.LatLngBounds();
        for (const polyline of this.polylinesMap.values()){
            const path = polyline.getPath();
            for(let i = 0; i < path.getLength(); i++)bounds.extend(path.getAt(i));
        }
        for (const marker of this.googleMapMarkerList.values()){
            const position = marker.position;
            if (position) bounds.extend(position);
        }
        if (bounds.isEmpty()) return;
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            const ne = bounds.getNorthEast();
            const offset = 0.001;
            const adjustedBounds = new google.maps.LatLngBounds({
                lat: ne.lat() - offset,
                lng: ne.lng() - offset
            }, {
                lat: ne.lat() + offset,
                lng: ne.lng() + offset
            });
            this.googleMapInstance.fitBounds(adjustedBounds);
        } else this.googleMapInstance.fitBounds(bounds);
    }
    /**
      * Adds a marker to the map using the specified coordinates and control.
      * This method can be used to display points of interest, locations, or other relevant markers on the map.
      *
      * @param coord The `Coord` object containing the marker's details (e.g., position, icon).
      * @param {any} control - An object that is associated with the marker.
      * @returns A promise that resolves once the marker has been successfully added to the map.
      * 
     */ async setMarker(coord, control) {
        if (!await this.isMapInitialized()) return;
        var latlng = new google.maps.LatLng(coord.latitude, coord.longitude);
        var existingMarker = this.googleMapMarkerList?.get(coord.markerId);
        if (existingMarker) {
            existingMarker.textContent = coord.caption;
            existingMarker.position = latlng;
            existingMarker.icon = coord.markerIcon;
            existingMarker.content = this.getMarkerContent(coord);
            this.markerClusterer?.removeMarker(existingMarker);
            this.markerClusterer?.addMarker(existingMarker);
            if (existingMarker.draggable != coord.draggable) {
                if (coord.draggable && !this.mapClickListener) this.invokeMarkerUpdateOnMapClick(control);
                existingMarker.draggable = coord.draggable;
            }
            return;
        }
        var newMarker = new google.maps.marker.AdvancedMarkerElement({
            position: latlng,
            map: this.googleMapInstance,
            content: this.getMarkerContent(coord),
            gmpDraggable: coord.draggable
        });
        newMarker.id = coord.markerId;
        newMarker.draggable = coord.draggable;
        this.markerClusterer?.addMarker(newMarker);
        if (newMarker.draggable && !this.mapClickListener) this.invokeMarkerUpdateOnMapClick(control);
        console.log(newMarker);
        newMarker.addListener("gmp-click", ()=>{
            if (!this.googleMapInstance) return;
            control.invokeMethodAsync("DisplayDetails", newMarker.id);
            const markerPosition = newMarker.position;
            if (markerPosition) this.googleMapInstance.setCenter(markerPosition);
        });
        if (coord.draggable == true) newMarker.addListener("dragend", ()=>{
            control.invokeMethodAsync("UpdateCoords", JSON.stringify(newMarker.position), newMarker.id);
        });
        this.googleMapMarkerList.set(newMarker.id, newMarker);
    }
    /**
     * Updates the map's markers to match a provided list of coordinates, potentially adding, updating, or removing markers.
     * This method ensures that the map's displayed markers accurately reflect a given set of `Coord` objects.
     *
     * @param coords An array of `Coord` objects representing the desired state of markers on the map.
     * @param control Additional control or settings applied to the markers (implementation specific).
     * @returns A promise that resolves once the markers have been synchronized with the provided coordinates.
     */ async syncMarkers(coords, control) {
        if (!await this.isMapInitialized()) return;
        try {
            let validCoordIds = new Set(coords.map((item)=>item.markerId));
            this.googleMapMarkerList.forEach((value, key)=>{
                if (!validCoordIds.has(key)) this.deleteMarker(key);
            });
            coords.forEach((coord)=>{
                this.setMarker(coord, control);
            });
        } catch (e) {
            console.log(e);
        }
    }
    async syncRoutes(routes) {
        if (!await this.isMapInitialized()) return;
        const currentRouteIds = new Set(routes.map((r)=>r.id));
        for (const [id, polyline] of this.polylinesMap.entries())if (!currentRouteIds.has(id)) {
            polyline.setMap(null);
            this.polylinesMap.delete(id);
        }
        for (const route of routes){
            const path = route.path.map((p)=>({
                    lat: p.latitude,
                    lng: p.longitude
                }));
            let polyline = this.polylinesMap.get(route.id);
            if (polyline) {
                polyline.setPath(path);
                polyline.setOptions({
                    strokeColor: route.strokeColor || "#FF0000",
                    strokeOpacity: route.strokeOpacity ?? 1.0,
                    strokeWeight: route.strokeWeight ?? 1.0
                });
            } else {
                polyline = new google.maps.Polyline({
                    path: path,
                    map: this.googleMapInstance,
                    strokeColor: route.strokeColor || "#FF0000",
                    strokeOpacity: route.strokeOpacity ?? 1.0,
                    strokeWeight: route.strokeWeight ?? 2.0
                });
                this.polylinesMap.set(route.id, polyline);
            }
        }
        await new Promise(requestAnimationFrame);
        await this.setBounds();
    }
    /**
     * Removes a specific marker from the map based on its identifier.
     * This method allows for the targeted removal of markers, making it useful for dynamic map updates.
     *
     * @param markerId The unique identifier of the marker to be removed.
     * @returns A promise that resolves once the specified marker has been successfully removed from the map.
     */ async deleteMarker(markerId) {
        if (!await this.isMapInitialized()) return;
        const marker = this.googleMapMarkerList.get(markerId);
        if (!marker) return;
        this.markerClusterer?.removeMarker(marker);
        google.maps.event.clearListeners(marker, "dragend");
        marker.map = null;
        this.googleMapMarkerList.delete(markerId);
    }
    /**
     * Removes all markers from the map.
     * This method is useful for clearing the map of all markers, often in preparation for adding new ones or resetting the map state.
     *
     * @returns A promise that resolves once all markers have been successfully removed from the map.
     */ async clearMarkers() {
        if (!await this.isMapInitialized()) return;
        this.googleMapMarkerList.forEach((x)=>{
            google.maps.event.clearListeners(x, "dragend");
            x.map = null;
        });
        this.googleMapMarkerList.clear();
        this.markerClusterer?.clearMarkers();
    }
    async toggleMarkersDraggable(isDraggable, control) {
        if (!await this.isMapInitialized()) return;
        this.googleMapMarkerList.forEach((marker)=>{
            google.maps.event.clearListeners(marker, "dragend");
            marker.gmpDraggable = isDraggable;
            marker.addListener("dragend", ()=>{
                control.invokeMethodAsync("UpdateCoords", JSON.stringify(marker.position), marker.id);
            });
        });
    }
    async resetMarkerCoords(lat, lng) {
        if (!await this.isMapInitialized()) return;
        this.googleMapMarkerList.forEach((marker)=>{
            var latlng = new google.maps.LatLng(lat, lng);
            marker.position = latlng;
        });
    }
    /**
     * Cleans up the map instance and releases resources.
     * This method should be called before the map controller is discarded to ensure proper cleanup of event listeners,
     * markers, and other map-related resources to prevent memory leaks.
     */ dispose() {
        if (this.mapClickListener) {
            google.maps.event.removeListener(this.mapClickListener);
            this.mapClickListener = undefined;
        }
        window.removeEventListener("resize", this.adjustMapHeight);
        window.removeEventListener("fullscreenchange", this.handleFullscreenChange);
        this.clearMarkers();
    }
    /**
     * Checks if the map has been successfully initialized and is ready for use.
     * This method might check for certain conditions or flags that indicate the map's initialization state.
     * Being a private method, it's used internally within the class to ensure operations that depend on an initialized map are executed appropriately.
     *
     * @returns A promise that resolves with a boolean indicating whether the map is initialized (true) or not (false).
     */ async isMapInitialized() {
        if (this.mapInitializedPromise) await this.mapInitializedPromise;
        if (!this.googleMapInstance) {
            console.warn(`Google Map instance (${this.mapId}) is not initialized yet.`);
            return false;
        }
        return true;
    }
    /**
     * Generates and returns a DOM Node representing the marker content for a given set of coordinates.
     *
     * @param {Coord} coord - The geographical coordinates for which the marker content is generated.
     * @returns {Node} A DOM Node representing the custom content for the map marker. This content can include
     * text, images, or any other HTML elements styled and positioned accoording to the specified coordinates.
     * 
     */ getMarkerContent(coord) {
        var markerContent;
        if (coord.markerIcon) {
            markerContent = document.createElement("img");
            markerContent.src = coord.markerIcon;
            markerContent.style.width = "30px";
            markerContent.style.height = "30px";
        } else {
            markerContent = document.createElement("div");
            markerContent.className = "default-marker";
            var pinTag = new google.maps.marker.PinElement().element;
            const captionTag = document.createElement("span");
            captionTag.className = "caption";
            captionTag.textContent = coord.caption;
            markerContent.appendChild(pinTag);
            markerContent.appendChild(captionTag);
        }
        return markerContent;
    }
    /**
     * Attaches a click event listener to the map, designed to update the position of a draggable marker
     * and synchronize these changes with a corresponding C# object.
     * When a draggable marker is moved, and the user clicks a new position on the map,
     * this method triggers the invocation of the `UpdateCoords` method on the specified C# object.
     * This allows for the seamless update of coordinates within the C# class, reflecting changes made on the map.
     * 
     * @param control The C# object that will have its `UpdateCoords` method invoked asynchronously
     * to update the marker's coordinates in the corresponding C# class. This integration enables a tight coupling
     * between the map's interactive features and the server-side logic defined in a C# application.
     */ invokeMarkerUpdateOnMapClick(control) {
        if (!this.googleMapInstance) return;
        if (this.mapClickListener) google.maps.event.removeListener(this.mapClickListener);
        this.mapClickListener = google.maps.event.addListener(this.googleMapInstance, "click", (event)=>{
            if (!this.googleMapInstance) return;
            const draggableMarkers = new Map([
                ...this.googleMapMarkerList
            ].filter(([key, marker])=>marker.draggable));
            if (!draggableMarkers || draggableMarkers.size != 1) return;
            const marker = draggableMarkers.values().next().value;
            console.log(event.latLng);
            marker.position = event.latLng;
            control.invokeMethodAsync("UpdateCoords", JSON.stringify(marker.position), marker.id);
            var position = marker.position;
            if (position) this.googleMapInstance.setCenter(position);
        });
    }
    /**
     * Asynchronously adjusts the height of a map element based on the client height of the main content element.
     * It ensures that the map has a minimum height that is slightly less than the height of the main content,
     * specifically reduced by 25 pixels to account for any additional margins or padding that may be desired.
     *
     * @returns A Promise that resolves to void. The asynchronous nature of this function allows for potential
     * asynchronous operations within, such as checking if the map is initialized.
     */ async adjustMapHeight() {
        if (!await this.isMapInitialized()) return;
        const mainContentElement = document.querySelector(".main-content");
        const mapElement = document.getElementById(this.mapId);
        if (mainContentElement && mapElement) {
            var mapMinHeight = mainContentElement.clientHeight - 25;
            mapElement.style.minHeight = `${mapMinHeight}px`;
        }
    }
    /**
     * Handles fullscreen changes by adjusting the map's position.
     * Sets the map's position to 'fixed' when in fullscreen mode, and 'relative' when not.
     */ async handleFullscreenChange() {
        if (!await this.isMapInitialized()) return;
        const mapElement = document.getElementById(this.mapId);
        if (!mapElement) return;
        const mapFullscreenElement = mapElement.children[0];
        if (!mapFullscreenElement) return;
        if (document.fullscreenElement === mapFullscreenElement) mapElement.style.position = "fixed";
        else mapElement.style.position = "relative";
    }
}


const $76d0adc711a7b432$var$mapControllers = new Map();
/**
 * Initializes a map with a specified ID and geographic coordinates. Creates a new `MapController`
 * instance, registers it, and initializes the map at the given location. Ensures map controllers
 * are managed centrally for easy access.
 */ async function $76d0adc711a7b432$var$initMap(mapId, latitude, longitude, autoHeightAdjustment) {
    const mapController = new (0, $94a9d645fcd9bc28$export$5cd6dd0a1d52a9dc)(mapId, googleMapsApiKey);
    $76d0adc711a7b432$var$mapControllers.set(mapId, mapController);
    await mapController.init(latitude, longitude, autoHeightAdjustment);
}
/**
 * Sets a marker on a specified map. Acts as a wrapper around `MapController.syncMarkers`.
 */ async function $76d0adc711a7b432$var$syncMarkers(mapId, coords, control) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map.syncMarkers(coords, control));
}
async function $76d0adc711a7b432$var$syncRoutes(mapId, routes) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map.syncRoutes(routes));
}
/**
 * Sets a marker on a specified map. Acts as a wrapper around `MapController.setMarker`.
 */ async function $76d0adc711a7b432$var$setMarker(mapId, cord, control) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map.setMarker(cord, control));
}
/**
 * Sets a marker on a specified map. Acts as a wrapper around `MapController.addCustomControl`.
 */ async function $76d0adc711a7b432$var$addCustomControl(mapId, itemId, position) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map.addCustomControl(itemId, position));
}
/**
 * Sets a marker on a specified map. Acts as a wrapper around `MapController.setBounds`.
 */ async function $76d0adc711a7b432$var$setBounds(mapId) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map?.setBounds());
}
/**
 * Sets a marker on a specified map. Acts as a wrapper around `MapController.setCenter`.
 */ async function $76d0adc711a7b432$var$setCenter(mapId, latitude, longitude) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map?.setCenter(latitude, longitude));
}
/**
 * Sets a marker on a specified map. Acts as a wrapper around `MapController.setZoom`.
 */ async function $76d0adc711a7b432$var$setZoom(mapId, zoom) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map?.setZoom(zoom));
}
/**
 * Sets a marker on a specified map. Acts as a wrapper around `MapController.deleteMarker`.
 */ async function $76d0adc711a7b432$var$deleteMarker(mapId, markerId) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map?.deleteMarker(markerId));
}
/**
 * Sets a marker on a specified map. Acts as a wrapper around `MapController.clearMarkers`.
 */ async function $76d0adc711a7b432$var$clearMarkers(mapId) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map?.clearMarkers());
}
async function $76d0adc711a7b432$var$toggleMarkersDraggable(mapId, isDraggable, control) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map?.toggleMarkersDraggable(isDraggable, control));
}
async function $76d0adc711a7b432$var$resetMarkerCoords(mapId, lat, lng) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>await map?.resetMarkerCoords(lat, lng));
}
/**
 * Sets a marker on a specified map. Acts as a wrapper around `MapController.dispose`.
 */ async function $76d0adc711a7b432$var$dispose(mapId) {
    await $76d0adc711a7b432$var$withMapController(mapId, async (map)=>{
        await map?.dispose();
        $76d0adc711a7b432$var$mapControllers.delete(mapId);
    });
}
/**
 * Executes a given asynchronous action on a `MapController` instance associated with a specific `mapId`.
 * This function checks if a `MapController` is registered for the provided `mapId` and, if so,
 * passes it to the provided action callback. If no corresponding `MapController` is found, it logs
 * a warning. This approach abstracts the error handling and lookup logic, simplifying operations on
 * `MapController` instances.
 * 
 * @param mapId The identifier of the map whose `MapController` is to be retrieved and used.
 * @param action An asynchronous callback function that performs operations on the retrieved `MapController`.
 * This function is expected to accept a `MapController` instance as its argument and return a Promise.
 * @returns A Promise that resolves once the action has been completed on the `MapController`, or nothing if
 * the `MapController` could not be found.
 */ async function $76d0adc711a7b432$var$withMapController(mapId, action) {
    const mapController = $76d0adc711a7b432$var$mapControllers.get(mapId);
    if (!mapController) {
        console.warn(`MapController for ${mapId} not found.`);
        return;
    }
    await action(mapController);
}
const $76d0adc711a7b432$var$mapsPublicFunctions = {
    controllers: $76d0adc711a7b432$var$mapControllers,
    initMap: $76d0adc711a7b432$var$initMap,
    setCenter: $76d0adc711a7b432$var$setCenter,
    setZoom: $76d0adc711a7b432$var$setZoom,
    setBounds: $76d0adc711a7b432$var$setBounds,
    setMarker: $76d0adc711a7b432$var$setMarker,
    syncMarkers: $76d0adc711a7b432$var$syncMarkers,
    syncRoutes: $76d0adc711a7b432$var$syncRoutes,
    addCustomControl: $76d0adc711a7b432$var$addCustomControl,
    deleteMarker: $76d0adc711a7b432$var$deleteMarker,
    clearMarkers: $76d0adc711a7b432$var$clearMarkers,
    toggleMarkersDraggable: $76d0adc711a7b432$var$toggleMarkersDraggable,
    resetMarkerCoords: $76d0adc711a7b432$var$resetMarkerCoords,
    dispose: $76d0adc711a7b432$var$dispose
};
window.maps = $76d0adc711a7b432$var$mapsPublicFunctions;

})();
//# sourceMappingURL=mapsScript.js.map
